import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Footer = () => {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitting(true);
    try {
      const { data } = await axios.post(`${API}/subscribe`, { email: email.trim() });
      if (data.message === "already_subscribed") {
        toast("You're already on the list.");
      } else {
        toast.success("Welcome to the list. Scent notes incoming.");
      }
      setEmail("");
    } catch {
      toast.error("Could not subscribe right now. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[var(--line)] py-12 px-6 max-w-6xl mx-auto"
    >
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <div className="flex items-center gap-3 text-[11px] text-[var(--ink)]/70">
          <span className="label-caps font-medium text-[var(--ink)]">BARE ESSENTIALS</span>
          <span className="opacity-40">&bull;</span>
          <span>Skincare Refined</span>
          <span className="opacity-40">&bull;</span>
          <span>Made in Canada</span>
        </div>

        <form
          onSubmit={handleSubscribe}
          data-testid="newsletter-form"
          className="flex items-stretch gap-0 w-full md:w-auto"
        >
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email for scent notes"
            data-testid="newsletter-email-input"
            className="border border-[var(--ink)]/40 bg-[var(--card-bg)] px-4 py-2.5 text-xs text-[var(--ink)] placeholder:text-[var(--ink)]/40 focus:outline-none focus:border-[var(--ink)] w-full md:w-64"
          />
          <button
            type="submit"
            disabled={submitting}
            data-testid="newsletter-submit-button"
            className="border border-[var(--ink)] bg-[var(--ink)] text-[var(--bg)] px-5 label-caps text-[10px] hover:bg-transparent hover:text-[var(--ink)] transition-colors disabled:opacity-50"
          >
            {submitting ? "Joining" : "Join"}
          </button>
        </form>
      </div>

      <div className="mt-8 pt-6 border-t border-[var(--line)] flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex gap-8 label-caps text-[10px] text-[var(--ink)]/70">
          <a href="#scents" data-testid="footer-link-scents" className="hover:text-[var(--ink)] transition-colors">
            Scents
          </a>
          <a href="#formula" data-testid="footer-link-ingredients" className="hover:text-[var(--ink)] transition-colors">
            Ingredients
          </a>
          <a href="#faq" data-testid="footer-link-faq" className="hover:text-[var(--ink)] transition-colors">
            FAQ
          </a>
        </div>
        <span className="text-[10px] text-[var(--ink)]/50 label-caps">
          All natural skin pheromone formulations
        </span>
      </div>
    </footer>
  );
};
